export class GalleryImage {
    src:string;
    position:number;
    alt:string;
    first:boolean;
    last:boolean;
    descripcion:string;
    containerID:String;
  }